// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    Typography,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import { getDoctag, getGudang } from '../../../api/helper'
import appInfo from '../../../configs/app-info'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [listData, setListData] = useState<any[]>([])
    const [listVendor, setListVendor] = useState<any[]>([])
    const [valVendor, setValVendor] = useState<any>(null)

    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [openDialog, setOpenDialog] = useState<boolean>(false)

    useEffect(() => {
        getData(tabs)
        getVendor()

        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.accapp, cabang, token);
            if (response.length > 0 && response.length === 1) {
                setValDoctag(response[0].nama)
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };

        fetchDoctag()
    }, [])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setListData([])
        let url = apiUrl.apiUrl + '/acc/app/list'

        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir,
                    mode: mode,
                    supplier: valVendor?.id ?? null
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getVendor = () => {
        axios.get(apiUrl.apiUrl + '/acc/app/get-vendor', {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            if (res.data.success) {
                setListVendor(res.data.data)
            }
        })
    }

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/acc/app/delete/' + row.id
        axios
            .post(url, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData(tabs)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    interface FormInputs {
        id: any
        sysdoctag_id: any
        tanggal: any
        keterangan: any
        total_bayar: any
        terlunasi: any
    }

    const defaultValues = {
        tanggal: moment().format('YYYY-MM-DD'),
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row)
            },
            {
                title: "Hapus",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(row: any) => {
                        navigate('/acc/app/detail/' + row.id)
                    }}
                />
            ),
        },
    ];

    const ActionButtonsOutstanding = ({ row }: {
        row: any;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<Icon icon="mdi:file-document-plus" />}
                    onClick={() => {
                        setValue('id', row.id)
                        setValue('total_bayar', row.total_bayar)
                        setValue('terlunasi', row.terlunasi)
                        setOpenDialog(true)
                    }}
                >
                    Buat Pelunasan
                </Button>
            </Box>
        );
    };

    const actionOutstanding = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsOutstanding
                    row={row}
                />
            ),
        },
    ];

    const hiddenColumns = ['id', 'jenis_dokumen', 'doc_type', 'doc_id', 'is_bg', 'is_aktif', 'sysdoctag_id']

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='AP PAYMENT' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            {/* <Fab
                                color='primary'
                                size='medium'
                                onClick={() => {
                                    navigate('/acc/app/add')
                                }}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab> */}
                        </Box>
                    </Box>
                    <Divider />
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Daftar Pelunasan' />
                            <Tab value='1' label='Outstanding DP' />
                            <Tab value='4' label='Outstanding Hutang' />
                            <Tab value='2' label='Jatuh Tempo' />
                            <Tab value='3' label='Kartu Hutang' />
                        </TabList>
                        <TabPanel value='0'>
                            <Grid
                                item
                                container
                                sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                                spacing={5}
                            >
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Awal'
                                            type='date'
                                            onChange={(e) => setTglAwal(e.target.value)}
                                            value={tglAwal}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>

                                        <TextField
                                            label='Tanggal Akhir'
                                            type='date'
                                            onChange={(e) => setTglAkhir(e.target.value)}
                                            value={tglAkhir}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl fullWidth>
                                        <Button
                                            variant='contained'
                                            sx={{ mt: 1 }}
                                            startIcon={<Icon icon='mdi:magnify' />}
                                            onClick={() => getData(tabs)}
                                        >
                                            Cari Data
                                        </Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <MsiDatagrid array={listData} actions={actionData} hiddenColumns={hiddenColumns} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} hiddenColumns={hiddenColumns} actions={actionOutstanding} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <MsiDatagrid array={listData} hiddenColumns={hiddenColumns} />
                        </TabPanel>
                        <TabPanel value='3'>
                            <Grid
                                item
                                container
                                sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                                spacing={5}
                            >
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Awal'
                                            type='date'
                                            onChange={(e) => setTglAwal(e.target.value)}
                                            value={tglAwal}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label='Tanggal Akhir'
                                            type='date'
                                            onChange={(e) => setTglAkhir(e.target.value)}
                                            value={tglAkhir}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        value={valVendor}
                                        options={listVendor}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.nama ?? ''}
                                        onChange={(_, val) => setValVendor(val)}
                                        renderInput={(params) => (
                                            <FormControl fullWidth>
                                                <TextField
                                                    {...params}
                                                    label="Vendor"
                                                />
                                            </FormControl>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl fullWidth>
                                        <Button
                                            variant='contained'
                                            sx={{ mt: 1 }}
                                            startIcon={<Icon icon='mdi:magnify' />}
                                            onClick={() => getData(tabs)}
                                            disabled={!valVendor}
                                        >
                                            Cari Data
                                        </Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <MsiDatagrid array={listData} hiddenColumns={hiddenColumns} />
                        </TabPanel>
                        <TabPanel value='4'>
                            <MsiDatagrid array={listData} hiddenColumns={hiddenColumns} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>

            <Dialog open={openDialog} maxWidth='sm' fullWidth>
                <DialogTitle>Buat Pelunasan</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit((data) => {
                        setOpenDialog(false)

                        const url = apiUrl.apiUrl + '/acc/app/add-pelunasan'

                        axios.post(url, data, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(res => {
                            const data = res.data.data[0]

                            showToast(res.data.message, 'success')
                            navigate('/acc/app/detail/' + data.id)
                        })

                    })}>
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12}>
                                <Controller
                                    name="sysdoctag_id"
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field }) => (
                                        <FormControl fullWidth>
                                            <TextField
                                                {...field}
                                                select
                                                label='Pilih Doctag'
                                            >
                                                <MenuItem value="" disabled>Pilih Doctag</MenuItem>
                                                {listDoctag.map((item) => (
                                                    <MenuItem key={item.id} value={item.id}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Controller
                                    name='tanggal'
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            type='date'
                                            label='Tanggal'
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name='keterangan'
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label='Keterangan'
                                            multiline
                                            rows={3}
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Controller
                                    name='total_bayar'
                                    control={control}
                                    render={({ field }) => (
                                        <Typography variant='body1' fontWeight={'bold'}>
                                            Total Bayar: {field.value || 0}
                                        </Typography>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Controller
                                    name='terlunasi'
                                    control={control}
                                    render={({ field }) => (
                                        <Typography variant='body1' fontWeight={'bold'}>
                                            Terlunasi: {field.value || 0}
                                        </Typography>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Button variant='contained' type='submit'>
                                    SIMPAN
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
